<script setup lang="ts">
defineProps<{
  currency: string | null;
  destinationCountryCode: string | undefined;
  isLoading: boolean;
}>();

const isLocationSelectorDialogOpen = ref(false);

const { getName: getLocalisedCountryName } = useLocalisedCountryName();
</script>

<template>
  <BaseSkeletonLoader
    v-if="isLoading"
    class="mt-2"
    :width="240"
    :height="24"
  />
  <div
    v-if="currency && destinationCountryCode"
    class="mt-2"
  >
    <BaseIcon
      name="locationPin"
      :size="18"
      class="!inline mr-2"
    />
    <I18nT
      keypath="product.description.shippingDetails.estimatedDeliveryCountry"
      tag="p"
      scope="global"
      class="inline"
    >
      <template #PLACEHOLDER_deliveryCountry>
        {{ getLocalisedCountryName(destinationCountryCode) }}
      </template>
    </I18nT>

    <span>
      -
      <button
        aria-label="open change address dialog"
        class="underline"
        @click="() => (isLocationSelectorDialogOpen = true)"
      >
        {{ $t("product.description.shippingDetails.changeLocation") }}
      </button>
    </span>

    <Teleport to="#teleports">
      <ProductShippingCountrySelectorDialog
        v-model="isLocationSelectorDialogOpen"
      />
    </Teleport>
  </div>
</template>
